function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "aa",
  cx: 48.645,
  cy: 48.645,
  r: 48.645
}), React.createElement("circle", {
  id: "cc",
  cx: 58,
  cy: 58,
  r: 58
}), React.createElement("circle", {
  id: "ee",
  cx: 38.667,
  cy: 38.667,
  r: 38.667
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("g", {
  opacity: 0.2,
  transform: "translate(9.355 9.355)"
}, React.createElement("mask", {
  id: "bb"
}, React.createElement("use", {
  xlinkHref: "#aa"
})), React.createElement("use", {
  xlinkHref: "#aa"
}), React.createElement("g", {
  mask: "url(#bb)"
}, React.createElement("path", {
  d: "M-9.355-8.731h117.871v117.87H-9.354z"
}))), React.createElement("g", {
  opacity: 0.2
}, React.createElement("mask", {
  id: "dd"
}, React.createElement("use", {
  xlinkHref: "#cc"
})), React.createElement("use", {
  xlinkHref: "#cc"
}), React.createElement("g", {
  mask: "url(#dd)"
}, React.createElement("path", {
  d: "M-10.66-10.032h140.455v140.454H-10.66z"
}))), React.createElement("g", {
  transform: "translate(19.333 19.333)"
}, React.createElement("mask", {
  id: "ff"
}, React.createElement("use", {
  xlinkHref: "#ee"
})), React.createElement("use", {
  xlinkHref: "#ee"
}), React.createElement("g", {
  mask: "url(#ff)"
}, React.createElement("path", {
  d: "M-8.108-7.484H85.44v93.548H-8.108z"
}))));

var SvgCircles = function SvgCircles(props) {
  return React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116"
  }, props), _ref, _ref2);
};

export default SvgCircles;


//////////////////
// WEBPACK FOOTER
// ./src/icons/circles.svg
// module id = 118
// module chunks = 0 1